import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DateOnly, Patient, PatientRepository, PatientSettings, PatientSettingsBase, TspPatientRepository } from '../core';
import { PatientSettingsForm } from '../models';
import { BaseService } from './base.service';


/**
 * This service handles patient data.
 */
@Injectable({ providedIn: 'root' })
export class PatientService extends BaseService {

	private readonly patientRepo = inject(PatientRepository);
	private readonly tspPatRepo = inject(TspPatientRepository);


	/**
	* Get patient by patient guid.
	* @param {string} patientGuid The patient guid.
	*/
	getPatient(patientGuid: string): Observable<Patient> {
		return this.patientRepo.getPatient(patientGuid).pipe(
			map(res => this._handleApiResponse(res))
		);
	}

	/**
	 * Get patient settings.
	 */
	getPatSettings(patId: string, userId: string): Observable<PatientSettings> {
		return this.tspPatRepo.getSettings(patId, userId).pipe(
			map(res => this._handleApiResponse(res))
		);
	}

	/**
	 * Save patient settings.
	 */
	savePatSettings(patId: string, settings: PatientSettingsBase): Observable<void> {
		return this.tspPatRepo.saveSettings(patId, settings).pipe(
			map(res => this._handleApiResponse(res))
		);
	}

	/**
	 * Map patient settings model to patient settings form. 
	 */
	patSettingsFormMapper(patStgs: PatientSettings | null): PatientSettingsForm | null {
		if (!patStgs) return null;
		return {
			email: patStgs.email,
			secondEmail: patStgs.secondEmail,
			pinSiteCareEnable: patStgs?.pinSiteCare.enable,
			firstDay: patStgs?.pinSiteCare.firstDay ? new DateOnly(patStgs?.pinSiteCare.firstDay) : undefined,
			frequency: patStgs?.pinSiteCare.frequency,
			mmEnable: patStgs?.motivationalMessage.enable,
			customSet: patStgs?.motivationalMessage.customSet,
			enabledSet: patStgs?.motivationalMessage.enabledSet,
			// pinSiteCarefile: this._fileMapper(patStgs?.files, FileCategory.PINSITECARE),
			// physiotherapyfile: this._fileMapper(patStgs?.files, FileCategory.PHYSIOTHERAPY),
		}
	}

	// private _fileMapper(files: PatientFileBase[] | undefined, category: FileCategory): PatientFile | undefined {
	// 	const file = files?.find(f => f.category === category);
	// 	return file ? { ...file, data: '' } : undefined;
	// }

	/**
	 * Save patient file.
	 */
	// saveFile(patientId: string, file: File, category: FileCategory): Observable<void> {
	// 	return this.tspPatRepo.saveFile(patientId, file, category).pipe(
	// 		map(res => this._handleApiResponse(res))
	// 	);
	// }

	/**
	 * Delete patient file.
	 */
	// deleteFile(patientId: string, category: FileCategory): Observable<void> {
	// 	return this.tspPatRepo.deleteFile(patientId, category).pipe(
	// 		map(res => this._handleApiResponse(res))
	// 	);
	// }

}
